import CampSelect from './CampSelect.vue'
import CampOptsSelect from './CampOptsSelect.vue'

export default {
    CampSelect,
    CampOptsSelect
}
